import { Authority } from '@/shared/security/authority';

const Marketer = () => import('@/pages/marketer/marketer.vue');

export default [
  // {
  //   path: '/marketer',
  //   name: 'Marketer',
  //   component: Marketer,
  //   meta: {
  //     layout: 'profile-layout',
  //     authorities: [Authority.MARKETER],
  //   },
  // },
  // {
  //   path: '/marketer/mod/:link',
  //   name: 'MarketerMod',
  //   component: Marketer,
  // },
];
